import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guard/auth.guard';
import { LoginComponent } from './layout/auth-layout/login/login.component';
import { GetLoginComponent } from './layout/get-login-layout/get-login.component';
import { TfAuthenticationLayoutComponent } from './layout/tf-authentication-layout/tf-authentication-layout.component';
import { UserRole } from './models/user-role.model';
import { TfcodeLayoutComponent } from './layout/tf-authentication-layout/tf-verificationcode-layout.component';

import { ForgetPasswordComponent } from './layout/forget-password/forgetpassword-component';
import { EnterPasswordResetCodeComponent } from './layout/forget-password/forgetpassword-enter-resetcode';
import { ResetPasswordComponent } from './layout/forget-password/reset-password-component';


const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'dxmapping',
    loadChildren: () => import('./dx-mapping/dx-mapping.module').then(m => m.DxMappingModule),
    canActivate: [AuthGuard], data: { roles: ['DXMapping'] }

  },
  {
    path: 'timesheet',
    loadChildren: () => import('./timesheet/timesheet.module').then(m => m.TimesheetModule),
    canActivate: [AuthGuard], data: { roles: ['Timesheet'] }

  },
  {
    path: 'users',
    loadChildren: () => import('./user-management/user-management.module').then(m => m.UserManagementModule),
    canActivate: [AuthGuard], data: { roles: ['UserManagement'] }

  },

  {
    path: 'login',
    component: LoginComponent,
    loadChildren: () =>
      import('./layout/auth-layout/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'get-login',
    component: GetLoginComponent,
    loadChildren: () =>
      import('./layout/get-login-layout/get-login.module').then(m => m.GetLoginModule)
  },
  {
    path: 'tf-authentication',
    component: TfAuthenticationLayoutComponent,
    loadChildren: () =>
      import('./layout/tf-authentication-layout/tf-authentication-layout.module').then(m => m.TFAutenticationModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tf-verfiyCode',
    component: TfcodeLayoutComponent,
    loadChildren: () =>
      import('./layout/tf-authentication-layout/tf-authentication-layout.module').then(m => m.TFAutenticationModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'forgetpassword',
    component: ForgetPasswordComponent,
    loadChildren: () =>
      import('./layout/forget-password/forgetpassword.module').then(m => m.ForgetPasswordModule)
  },
  {
    path: 'passwordresetcode',
    component: EnterPasswordResetCodeComponent,
    loadChildren: () =>
      import('./layout/forget-password/forgetpassword.module').then(m => m.ForgetPasswordModule)
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    loadChildren: () =>
      import('./layout/forget-password/forgetpassword.module').then(m => m.ForgetPasswordModule)
  },
  {
    path: 'dxsalesledger',
    loadChildren: () => import('./dx-mapping/dx-mapping.module').then(m => m.DxMappingModule),
    canActivate: [AuthGuard], data: { roles: ['dxsalesledger'] }

  },  {
    path: 'dxcandidate',
    loadChildren: () => import('./dx-mapping/dx-mapping.module').then(m => m.DxMappingModule),
    canActivate: [AuthGuard], data: { roles: ['dxcandidate'] }

  },  {
    path: 'dxassignment',
    loadChildren: () => import('./dx-mapping/dx-mapping.module').then(m => m.DxMappingModule),
    canActivate: [AuthGuard], data: { roles: ['dxassignment'] }

  },  {
    path: 'dxassignmentrate',
    loadChildren: () => import('./dx-mapping/dx-mapping.module').then(m => m.DxMappingModule),
    canActivate: [AuthGuard], data: { roles: ['dxassignmentrate'] }

  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
